export default "__VITE_ASSET__CaZgjfTl__"